import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
    selector: 'app-bell',
    templateUrl: './bell.component.svg',
    styleUrls: ['./bell.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BellComponent {}
